import Summary from 'views/components/Validation/Summary/Summary';

export default Summary;
